import { render, staticRenderFns } from "./indicator_by_year_simple.vue?vue&type=template&id=0eea097d"
import script from "./indicator_by_year_simple.vue?vue&type=script&lang=js"
export * from "./indicator_by_year_simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports